<script setup lang="ts">
import {
  useBrowserStore,
  useMapStore,
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { TabKey } from '@apps/main/new-desktop/core/stores/configurationPanel/configurationPanelStore.model';

import {
  useTripOverviewModalsStore,
  useTripOverviewPanelsStore,
} from '../../stores';

import TripOverviewHeaderDesktop from './TripOverviewHeaderDesktop.vue';
import TripOverviewHeaderMoblie from './TripOverviewHeaderMoblie.vue';

const tripOverviewModalsStore = useTripOverviewModalsStore();
const mapStore = useMapStore();
const tripOverviewPanelsStore = useTripOverviewPanelsStore();
const browserStore = useBrowserStore();
const statsigEventsStore = useStatsigEventsStore();
const routerStore = useRouterStore();

function openPaxSelectorModal(): void {
  tripOverviewPanelsStore.openConfigurationPanel(
    TabKey.Pax,
    'overview-header-actions'
  );
}

function openEditTripModal(): void {
  tripOverviewPanelsStore.openConfigurationPanel(
    TabKey.Itinerary,
    'overview-header-actions'
  );
}

function onHomeAirportClick(): void {
  tripOverviewPanelsStore.openConfigurationPanel(
    TabKey.Airplane,
    'overview-header-actions'
  );
  statsigEventsStore.logTripOverviewFlyFromButtonClicked();
}

function openMonthsSelectorModal(): void {
  tripOverviewPanelsStore.openConfigurationPanel(
    TabKey.Calendar,
    'overview-header-actions'
  );
}

function openDynamicFullScreenMap(): void {
  mapStore.openFullScreenDynamicTripMap();
}

function openPremadeTripDetailsModal(): void {
  tripOverviewModalsStore.openPremadeTripDetailsModal;
}

function navigateToCarTrip(): void {
  routerStore.navigateToCarTrip();
}
</script>

<template>
  <TripOverviewHeaderMoblie
    v-if="browserStore.isSmallerThan900px"
    @open-premade-trip="openPremadeTripDetailsModal"
    @pax-click="openPaxSelectorModal"
    @home-airport-click="onHomeAirportClick"
    @edit-trip="openEditTripModal()"
    @months-selector-click="openMonthsSelectorModal()"
    @map-click="openDynamicFullScreenMap"
    @navigate-to-car-trip="navigateToCarTrip"
  />
  <TripOverviewHeaderDesktop
    v-else
    :print-mode="false"
    @open-premade-trip="openPremadeTripDetailsModal"
    @pax-click="openPaxSelectorModal"
    @home-airport-click="onHomeAirportClick"
    @edit-trip="openEditTripModal()"
    @months-selector-click="openMonthsSelectorModal()"
    @map-click="openDynamicFullScreenMap"
    @navigate-to-car-trip="navigateToCarTrip"
  />
</template>
